// extracted by mini-css-extract-plugin
export var embedContainer = "video-module--embed-container--31b44";
export var full = "video-module--full--d6257";
export var fullPage = "video-module--full-page--9ba05";
export var half = "video-module--half--32192";
export var inner = "video-module--inner--9330b";
export var threequarters = "video-module--threequarters--1f278";